export enum SiteEnum {
  Amm = 'amm',
  Ammom = 'ammom',
  Somos = 'somos',
}